import React from 'react'

import { Box } from '@mui/system'
import sectorText from 'assets/images/sector-footer.png'
import enamad from 'assets/images/enemad.svg'
import goUp from 'assets/images/goUp.svg'
import melisabt from 'assets/images/namad.svg'
import soorinLogo from 'assets/images/soorinlogo.png'

import style from './Footer.module.scss'
import logo from 'assets/images/sectorLogos/columnLogo.svg'
import footerbg from 'assets/images/illustrations/footer.svg'
import { Button, Container, Icon, Typography } from '@mui/material'
import { InstaIcon, TwitterIcon, FacebookIcon } from 'Sui_Icons'

export const Footer = () => {
    return (
        <Container maxWidth='xxl'>

            <Box sx={{ background: 'white', backgroundImage: `url(${footerbg})`, backgroundPosition: 'revert', position: 'relative', mt: 20, flex: 1, minHeight: '200px', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                <img src={sectorText} className={style.sectorText} />

                <Box sx={{ maxWidth: { xs: 66, lg: 86 }, mt: 4, mb: 2 }}><img src={logo} className={style.logo} /></Box>

                <Box sx={{ display: 'flex', flexDirection: 'row', my: 1 }}>
                    <Button sx={{ color: 'GrayText', fontSize: '14px' }}>سکتور چیست؟</Button>
                    <Button sx={{ color: 'GrayText', fontSize: '14px' }}>سوالات متداول</Button>
                    <Button sx={{ color: 'GrayText', fontSize: '14px' }}>قوانین و مقررات</Button>
                </Box>

                <Box sx={{ display: 'flex', background: 'white', justifyContent: 'space-between', flexDirection: { xs: 'column', lg: 'row' }, p: 3, my: 3, alignItems: 'center', borderRadius: 2, backgroundColor: '#0F2441', width: '90%' }}>

                    <Box sx={{ display: 'flex', flexDirection: 'column', flexBasis: { lg: '60%' }, justifyContent: 'center' }}>
                        <Typography gutterBottom>
                            <Typography fontSize={'20px'} fontWeight='700' color='#fff' variant='h6' display={'inline'}>درباره</Typography>
                            &nbsp;
                            <Typography fontSize={'20px'} color='primary.main' fontWeight='700' variant='h6' display={'inline'}>سکتور</Typography>
                        </Typography>
                        <Typography color='#8EA7C6'>
                            سکتور پلتفرم آموزشی بستری آنلاین است که به صورت تعاملی و بدون نیاز به معلم، مهم ترین نیازهای دنیای امنیت سایبری را به شما آموزش می دهد. علاوه بر بهره مندی از آموزش های تعاملی متنوع، امکان شرکت در آزمون و اخذ گواهینامه را با کمترین زمان و هزینه برای مخاطبان فراهم می سازد.
                        </Typography>
                    </Box>

                    <Box sx={{ cursor: 'pointer', my: { xs: 4, lg: 0 }, width: { xs: '100%', lg: '20%' }, display: 'flex', justifyContent: 'space-around', '& img': { height: '70px', width: 'auto' } }}>
                        <img className={style.nemad} src={melisabt} />
                        <img className={style.nemad} src={enamad} />

                    </Box>


                </Box>
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, width: '93%', justifyContent: 'space-between', alignItems: 'center' }}>


                    <Box sx={{ display: 'flex', alignItems: 'center', width: { xs: '100%', lg: '100%' }, justifyContent: 'space-between' }} >

                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { lg: 'space-between' }, flex: { lg: 0.7 }, flexDirection: { xs: 'column', lg: 'row' } }}>

                            <Box sx={{ display: 'flex', alignItems: 'center' }} order={{ xs: 2, lg: 1 }}>
                                <img src={soorinLogo} />
                                <Typography align='left' color='#8EA7C6' sx={{ ml: 1 }}>ساخته شده توسط سورین</Typography>
                            </Box>
                            <Box order={{ xs: 1, lg: 2 }}>
                                <InstaIcon sx={{ mx: 2, cursor: 'pointer' }} fontSize={'large'} />
                                <TwitterIcon sx={{ mx: 2, cursor: 'pointer' }} fontSize={'large'} />
                                <FacebookIcon sx={{ mx: 2, cursor: 'pointer' }} fontSize={'large'} />
                            </Box>
                        </Box>

                        <Box sx={{ mt: 2, maxHeight: '80px', overflow: 'hidden', cursor: 'pointer' }} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} >
                            <img src={goUp} />
                        </Box>

                    </Box>

                </Box>

            </Box>
        </Container >
    )
}
